/** 电话/联系方式行业标准长度（ITU E.164、国内号段实践） */
export const PHONE_LIMITS = {
  /** 中国大陆手机号固定 11 位 */
  cnLength: 11,
  /** E.164 数字部分最长 15 位 */
  intlDigitMaxLength: 15,
  /** 联系电话（含 +、空格、短横线） */
  contactTelMaxLength: 32,
  /** 境内联系电话输入（含格式符，与接口 CONTACT_PHONE_INPUT_MAX 一致） */
  contactPhoneInputMax: 20,
  /** 境外电话（库 varchar(20)） */
  overseasPhoneMaxLength: 20,
  /** 公示电话 / SOS / 24 小时热线 */
  publicTelMaxLength: 64,
  /** 紧急联系方式（微信/电话/邮箱等混合） */
  emergencyContactMaxLength: 128,
  /** 短信 OTP */
  otpLength: 6,
  /** 图形验证码 */
  picCaptchaMaxLength: 8,
  /** 列表精确检索：身份证 18 位 / 手机 11 位取较长者 */
  exactIdentitySearchMaxLength: 18,
  /** 姓名/身份证组合检索（姓名可模糊） */
  nameIdSearchMaxLength: 30,
} as const

export const CN_MOBILE_PATTERN = /^1\d{10}$/

/** 是否为合法中国大陆手机号（trim 后） */
export function isCnMobile(value: string): boolean {
  const v = String(value ?? '').trim()
  return v.length === PHONE_LIMITS.cnLength && CN_MOBILE_PATTERN.test(v)
}

/** 联系电话：大陆手机或国际格式如 +66-123456789 */
export function isContactTel(value: string): boolean {
  const v = String(value ?? '').trim()
  if (!v) return false
  if (CN_MOBILE_PATTERN.test(v)) return true
  if (v.length > PHONE_LIMITS.contactTelMaxLength) return false
  return /^\+[\d\-–\s()]{8,30}$/.test(v) || /^[\d\-–\s()]{8,30}$/.test(v)
}

/** 公示/热线类电话（允许区号、+、括号等） */
export function isPublicTel(value: string): boolean {
  const v = String(value ?? '').trim()
  if (!v) return true
  if (v.length > PHONE_LIMITS.publicTelMaxLength) return false
  return /^[\d+\-\s()（）]{4,64}$/.test(v)
}

/** 技术支持电话：手机 / 400 / 固话 */
export function isSupportPhone(value: string): boolean {
  const v = String(value ?? '').trim()
  if (!v || v.length > PHONE_LIMITS.publicTelMaxLength) return false
  return /^(1\d{10}|400[\d-]{7,}|0\d{2,3}-?\d{7,8})$/.test(v)
}

/** @deprecated 使用 isCnMobile */
export const isValidChinaMobile = isCnMobile

/** @deprecated 使用 isContactTel */
export const isValidContactPhone = isContactTel
